import { OutboundLink } from "react-ga";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  arrow: {
    padding: 0,
    borderRight: "4px solid",
    borderBottom: "4px solid",
    borderColor: "white",
    color: "white",
    width: "27px",
    height: "27px",
    transform: "rotate(45deg)",
    display: "inline-block",
    animationTimingFunction: "ease",
  },
  "@keyframes bounce": {
    "0%": {
      transform: "translateY(0)"
    },
    "20%": {
      transform: "translateY(0)"
    },
    "50%": {
      transform: "translateY(0)"
    },
    "80%": {
      transform: "translateY(0)"
    },
    "100%": {
      transform: "translateY(0)"
    },
    "40%": {
      transform: "translateY(-30px)"
    },
    "60%": {
      transform: "translateY(-15px)"
    }
  },
  bounce: {
    animation: "bounce 2.5s infinite",
    width: "0px",
    height: "0px",
    paddingRight: "0.85rem"
  }
});

class BouncingArrow extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  };

  state = {
    page: ""
  };

  componentDidMount() {
    if ( typeof window !== "undefined") {
      this.setState({
        page: window.location.pathname
      })        
    }
  };

  render() {
    const { classes } = this.props;
    return(
      <div className={classes.bounce}>
        <OutboundLink
          id="arrowbutton"
          className={classes.arrow}
          to={this.state.page === "/gov/" ? "#video" : "#features"}
          eventLabel="Bouncing arrow"
        />
      </div>
    )
  }
}

export default injectSheet(styles)(BouncingArrow);



// WEBPACK FOOTER //
// ./src/components/Hero/BouncingArrow.jsx